import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import Preloader from "@/components/Preloader";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Products from "@/components/Products";
import Services from "@/components/Services";
import BuyGold from "@/components/BuyGold";
import Testimonials from "@/components/Testimonials";
import Instagram from "@/components/Instagram";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function Home() {
  useLenis();
  return (
    <div className="grain relative bg-[#F7F5F2] text-[#1C1C1A] min-h-screen">
      <Preloader />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Products />
        <Services />
        <BuyGold />
        <Testimonials />
        <Instagram />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
